const actionTypes = {
    UPDATE_SDU_SUBSCRIPTION: 'UPDATE_SDU_SUBSCRIPTION',
    LOAD_BCC_CONTENT: 'LOAD_BCC_CONTENT'
};

module.exports = actionTypes;
